import React from "react";
import { InputText } from "primereact/inputtext";
import styles from "./index.module.css";

export default class Input extends React.Component {
  render() {
    return (
      <div
        className={
          styles.container +
          (this.props.className ? " " + this.props.className : "")
        }
      >
        {this.props.label ? (
          <label className={styles.label}>
            {this.props.label}
            {this.props.required ? (
              <span style={{ color: "#EB5757" }}>*</span>
            ) : (
              ""
            )}
          </label>
        ) : null}

        <InputText
          value={this.props.value}
          onChange={(e) => {
            this.props.onChange(e.target.value);
          }}
          v-model="value1"
          className={styles.input + (this.props.grey ? " " + styles.grey : "")}
          placeholder={this.props.placeholder}
          disabled={this.props.disabled}
          required={this.props.required}
          type={this.props.type}
        />
        {this.props.description ? (
          <small id="username-help">
            Enter your username to reset your password.
          </small>
        ) : null}
      </div>
    );
  }
}
